import { createSelector } from 'reselect';
import { connect } from 'react-redux';

import {
  selectAbn,
  selectTrusteeValidationResult,
  selectTrusteeValidationErrorMessage,
  selectMainTrustDeedAttachment,
} from '../../../selectors';
import registrationApi from '../../../api/registrationApi';
// eslint-disable-next-line import/no-cycle
import {
  saveTrusteeDetails,
  checkTrusteeEligibility,
  resetTrusteeValidationResult,
} from './actions';
import LocateYourTrustee from './Component';
import { trusteeOptions } from './constants';

const mapStateToProps = createSelector(
  selectAbn,
  selectTrusteeValidationResult,
  selectTrusteeValidationErrorMessage,
  selectMainTrustDeedAttachment,
  (abn, validationResult, errorMessage, trustDeedAttachmentConfig) => ({
    abn,
    validationResult,
    errorMessage,
    trusteeOptions,
    trustDeedAttachmentConfig,
  }),
);

// eslint-disable-next-line arrow-body-style
const mapDispatchToProps = (dispatch) => {
  return {
    submitTrusteeDetails: (values, callback) => dispatch(saveTrusteeDetails(values, callback)),
    isEligible: (abn) => dispatch(checkTrusteeEligibility(abn)),
    reset: () => dispatch(resetTrusteeValidationResult()),
    searchCompany: (keyword) => registrationApi.searchCompany(keyword),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LocateYourTrustee);
